module.exports = __webpack_public_path__ + "profile-personal-bg.ce0a7f199e64ac896d14.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/corporate/img/profile-personal-bg.jpg
// module id = ../../../../../src/assets/corporate/img/profile-personal-bg.jpg
// module chunks = styles